module.exports = __webpack_public_path__ + "4dd54c0629f33f197adcfa87efc14c3f.MP3";